import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import FolderTreeSkeleton from '@/components/doc-control/FolderTreeSkeleton'

const NAME_WIDTHS = ['w-3/5', 'w-2/5', 'w-1/2', 'w-3/4', 'w-1/3']

/** Placeholder rows for the document list while a folder's documents load. */
export const DocumentSelectorListSkeleton: React.FC = () => (
  <div>
    <div className="flex h-9 items-center gap-3 border-b px-3">
      <Skeleton className="h-4 w-4" />
      <Skeleton className="h-3 w-20" />
      <Skeleton className="ml-auto h-3 w-12" />
    </div>
    {NAME_WIDTHS.map((width, i) => (
      <div key={i} className="flex h-10 items-center gap-3 border-b px-3">
        <Skeleton className="h-4 w-4 shrink-0" />
        <Skeleton className="h-5 w-4 shrink-0" />
        <Skeleton className={cn('h-4', width)} />
        <Skeleton className="ml-auto h-5 w-8 shrink-0 rounded-full" />
        <Skeleton className="h-4 w-12 shrink-0" />
      </div>
    ))}
  </div>
)

/** The whole two-pane body while the folder tree loads. */
const DocumentSelectorModalSkeleton: React.FC = () => (
  <div className="grid gap-4 md:grid-cols-[20rem_minmax(0,1fr)]">
    <div className="flex flex-col gap-2">
      <Skeleton className="h-4 w-16" />
      <div className="h-48 rounded-md border p-1.5 md:h-[400px]">
        <FolderTreeSkeleton />
      </div>
    </div>
    <div className="flex flex-col gap-2">
      <Skeleton className="h-4 w-20" />
      <div className="h-72 overflow-hidden rounded-md border md:h-[400px]">
        <DocumentSelectorListSkeleton />
      </div>
    </div>
  </div>
)

export default DocumentSelectorModalSkeleton
